import React, { useEffect, useState, useRef } from "react";
import SessionContentPopover from "./SessionContentPopover";
import {
  Div,
  MenuItem,
  DownloadIcon,
  MoreIcon,
  EditIcon,
  DeleteIcon
} from "components/Base";
import DeleteConfirmationPopover from "./DeleteConfirmationPopover.js";
import {
  canAdminUserEditContent,
  canAdminUserDeleteContent
} from "../selectors";
import * as flags from "utils/feature-flags";
import { selectFeatureFlag } from "@flopflip/react-redux";

import { connect } from "react-redux";
import { actions } from "../model";

import { EDIT_DOCUMENT_MIMETYPES } from "../constants";

const decorate = connect(
  state => ({
    canAdminUserEditContent: canAdminUserEditContent(state),
    canAdminUserDeleteContent: canAdminUserDeleteContent(state),
    canEditDocuments: selectFeatureFlag(flags.CAN_VIEW_EDIT_DOCUMENT.NAME)(
      state
    )
  }),
  {
    downloadFile: actions.downloadFile,
    deleteFile: actions.deleteFile,
    deleteAllVersions: actions.deleteAllVersions,
    showEditTypeModal: actions.setShowEditTypeModal,
    showEditDocumentPage: actions.showEditDocumentPage
  }
);

const useOverlay = (menu, close) => {
  useEffect(() => {
    const clickOutsideHandler = event => {
      let isClickInside;

      if (menu.current && menu.current.contains(event.target)) {
        isClickInside = true;
      }

      if (!isClickInside) {
        close();
      }
    };
    document.addEventListener("click", clickOutsideHandler);

    return () => document.removeEventListener("click", clickOutsideHandler);
  }, []);
};

const UploadContentMenu = ({
  isFirst,
  fileMimetype,
  fileId,
  downloadFile,
  showEditTypeModal,
  showEditDocumentPage,
  deleteFile,
  canAdminUserEditContent,
  canAdminUserDeleteContent,
  canEditDocuments,
  viaPortal
  // deleteAllVersions,
}) => {
  const [open, setOpen] = useState(false);
  const [confirmIsOpen, setConfirmIsOpen] = useState(false);
  const menuRef = useRef(null);
  useOverlay(menuRef, () => {
    setOpen(false);
    setConfirmIsOpen(false);
  });
  const closePopover = () => {
    setOpen(false);
  };
  return (
    <SessionContentPopover
      menuRef={menuRef}
      onLabelClick={() => setOpen(!open)}
      isOpen={open}
      Label={<MoreIcon size={26} ml={4} />}
    >
      <Div bra={3} bg="white" py={2} width={132}>
        <MenuItem
          LeftIcon={DownloadIcon}
          onClick={() => {
            downloadFile(fileId);
            closePopover();
          }}
        >
          Download file
        </MenuItem>

        {isFirst && canAdminUserEditContent ? (
          <MenuItem
            LeftIcon={EditIcon}
            onClick={() => {
              showEditTypeModal(fileId);
              closePopover();
            }}
          >
            Edit file type
          </MenuItem>
        ) : null}

        {isFirst &&
        !viaPortal &&
        canAdminUserEditContent &&
        canEditDocuments &&
        EDIT_DOCUMENT_MIMETYPES.includes(fileMimetype) ? (
          <MenuItem
            LeftIcon={EditIcon}
            onClick={() => {
              showEditDocumentPage(fileId);
              closePopover();
            }}
          >
            Edit document
          </MenuItem>
        ) : null}

        {canAdminUserDeleteContent ? (
          <DeleteConfirmationPopover
            onClose={() => setConfirmIsOpen(false)}
            onLabelClick={() => {
              setConfirmIsOpen(!confirmIsOpen);
            }}
            isOpen={confirmIsOpen}
            onConfirm={() => {
              deleteFile(fileId);
              setConfirmIsOpen(false);
            }}
            Label={
              <MenuItem
                LeftIcon={DeleteIcon}
                onClick={() => {
                  setConfirmIsOpen(!confirmIsOpen);
                }}
              >
                Delete file
              </MenuItem>
            }
          ></DeleteConfirmationPopover>
        ) : null}
      </Div>
    </SessionContentPopover>
  );
};

export default decorate(UploadContentMenu);
